import React from 'react';
import { useTranslation } from 'react-i18next';
import { useMutation } from '@tanstack/react-query';
import { toast } from 'sonner';
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger, } from '@/components/ui/alert-dialog';
import { deleteTrackingLink } from '@/services/tracking-link';
export const DeleteTrackingLinkDialog = ({ link, onDeleted, trigger, }) => {
    const { t } = useTranslation();
    const { mutate, isPending } = useMutation({
        mutationFn: deleteTrackingLink,
        onSuccess: (data) => {
            toast.success(data.message);
            onDeleted?.();
        },
        onError: () => toast.error(t('occurred', { ns: 'error' })),
    });
    return (<AlertDialog>
            <AlertDialogTrigger asChild>{trigger}</AlertDialogTrigger>
            <AlertDialogContent>
                <AlertDialogHeader>
                    <AlertDialogTitle>{t('delete')}</AlertDialogTitle>
                    <AlertDialogDescription>
                        {t('campaigns.tracking_links.delete.confirmation', { ns: 'glossary' })}
                    </AlertDialogDescription>
                </AlertDialogHeader>
                <AlertDialogFooter>
                    <AlertDialogCancel disabled={isPending}>{t('cancel')}</AlertDialogCancel>
                    <AlertDialogAction onClick={() => mutate({ publicId: link.publicId })} disabled={isPending}>
                        {isPending ? t('deleting') : t('delete')}
                    </AlertDialogAction>
                </AlertDialogFooter>
            </AlertDialogContent>
        </AlertDialog>);
};
DeleteTrackingLinkDialog.displayName = 'DeleteTrackingLinkDialog';
